<!-- 申请试用列表 -->
<template>
  <div style="min-width:900px;">
    <div v-if="!orig_module">
      <div style="width:60%;margin:0 auto;">
          <el-form :model="addForm"  label-width="80px"  ref="editForm" style="background: #f4f4f4;padding: 30px 20px 20px 20px;">
            <el-form-item label="试用模块" prop="title">
              <div style="background:#fff;width:70%;height:300px;overflow:auto">
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox style="float: left;clear: left;margin-left:20px;position:relative;top:0px;" v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="试用期限" prop="origin">
              <el-select v-model="value" placeholder="请选择">
                <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
      </div>
      <el-button style="position:relative;left:47%;top:80px;" type="primary" @click.native="formSubmit" :loading="editLoading">提交</el-button>
    </div>
    <div v-else style="text-align:center;">
      <slide-verify style="margin:0 auto;" @success="onSuccess" @fail="onFail" @refresh="onRefresh" :slider-text="texts"></slide-verify>
      <span v-if="!statused" style="position:relative;top:40px;color:#3280fc;"> 正在等待审核，请等待！</span>
      <span v-else style="position:relative;top:40px;color:#3280fc;"> 已授权,请在我的产品查看！</span>
      </br>
      <el-button style="position:relative;top:80px;" type="primary" @click.native="cancelSubmit" :loading="cancelLoading">取消试用</el-button>
    </div>

    <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a></p>
      </div>
    </div>
  </div>
  

</template>
<script>
import { API__code,API__login, API__account, API__trial,API_Models } from '../../../api/index.js'
//const cityOptions = ['模块1', '模块2', '模块3', '模块4', '模块5', '模块6'];
export default {
  inject:['reload'],
  data(){
    return {
      orig_module:'',
      value:'',
      checkedCities:[],
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      checked:'',
      cities: [],
      citiesd: [],
      userModule:[],
      addForm:{},
      smsCode:'',
      disabled:false,
      names:'',
      editLoading:false,
      checkCode:'',
      token:'',
      id:'',
      moudel:{
        name:1
      },
      checkedCount:[],
      cancelLoading:false,
      msg:"",
      texts: '滑动验证',
      statused:false,
    }
  },
  methods:{
    onSuccess(){
        this.msg = 'success';
        this.texts = "成功";
    },
    onFail(){
        this.msg = ''
    },
    onRefresh(){
        this.msg = ''
    },
    cancelSubmit:function(){
      if(this.msg !="success"){
        this.$message.error('请拖到图片进行验证！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        id:this.id,
        userModule:[],
      }
      API__trial.setUserModule(param)
      .then((res) =>{
        if(res.data.code = API__code.SUCCESS){
          this.$message({
              message: '取消成功',
              type: 'success',
              center:true
          });
          
          sessionStorage.setItem('module', '');
          this.reload();
          //this.getTrialList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('服务器异常，请您稍后再试..');
      });
    },
    formSubmit:function(){
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let hours = nowDate.getHours();
      let minutes = nowDate.getMinutes();
      let seconds = nowDate.getSeconds();
      if(seconds<10){
        seconds = '0'+seconds;
      }
      // 默认日期赋值
      var itime = year +"-"+ month +"-" +day+" "+hours +":"+ minutes+":"+seconds;

      var userModuled ={
        "status":false,
        "date":itime,
        "duration":this.value,
        "module":this.userModule,
      };       

      let param = {
        token:this.token,
        checkCode:this.checkCode,
        id:this.id,
        userModule:JSON.stringify(userModuled),
      }
      API__trial.setUserModule(param)
      .then((res) =>{
        if(res.data.code = API__code.SUCCESS){
          this.$message({
              message: '提交成功',
              type: 'success',
              center:true
          });
          sessionStorage.setItem('module', JSON.stringify(userModuled));
          this.reload();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('服务器异常，请您稍后再试..');
      });
    },
    
    handleCheckedCitiesChange(value) {
      this.userModule = [];
      for(var i=0;i<value.length;i++){
        for(var k=0;k<this.citiesd.length;k++){
          if(value[i] == this.citiesd[k].modulename){
            var jsoned = {"id":this.citiesd[k].id};
            this.userModule.push(jsoned);
          }
        }
      }
    },
    //发送验证码
    sendCode() {
        let para = {
            phone: this.token,
        };
        API__login.sendSmsCode(para)
        .then((res) =>{
            if(res.data.code == API__code.SUCCESS ){
                this.$message({
                    message: '发送成功',
                    type: 'success',
                    center:true
                });
                this.time = 60;
                this.disabled = true;
                this.timer();
            }else{
                this.$message.error(res.data.message);
                if(res.data.code == 403){
                  this.$router.push({path: 'login'});
                }
            }
        }).catch(err =>{
              this.$message.error('服务器异常，请您稍后再试..');
              this.pageLoading = false;
        });
    },
    //60S倒计时
    timer() {
        if (this.time > 0) {
            this.time--;
            this.btntxt = this.time + "s后重新获取";
            setTimeout(this.timer, 1000);
        } else {
            this.time = 0;
            this.btntxt = "获取验证码";
            this.disabled = false;
        }
    },
    
    getTrialList:function(){
      this.editLoading = true;
      let param = {
        token:this.token,
        id:this.id,
        checkCode:this.checkCode,
      }
      API__trial.getUserModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            if(res.data.data.status){
              this.statused = true;
            }else{
              this.statused = false;
            }
            this.orig_module = true;
          }else{
            this.orig_module = false;
          }
          
         // this.moudel = res.data.data;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
        this.editLoading = false;
        this.$message.error('服务器异常，请您稍后再试..');
      });
    },
    getModels:function(){
      let param = {
        // id:this.id,
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Models.getAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.models = res.data.data;
          this.cities=[];
          this.citiesd = [];
          for(var i =0;i<res.data.data.length;i++){
            this.cities.push(res.data.data[i].modulename);
            var jsones = {"modulename":res.data.data[i].modulename,"id":res.data.data[i].id};
            this.citiesd.push(jsones);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('服务器异常，请您稍后再试..');
      });
    },
    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnypt_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnypt_checkCode') {
                this.checkCode = arr2[1];
            }
            // else if (arr2[0] == 'dnnypt_id') {
            //     this.id = arr2[1];
            // }
        }
      }
    },
  },
  mounted(){
    this.orig_module = sessionStorage.getItem('module');
    this.getModels();
    this.getTrialList();
  },
  created(){
    this.getCookie();
  },

}
</script>
<style scoped lang="scss">
.el-radio-group{
  margin: 10px;
}
h3{
    font-weight: bold;
    font-size: 15px;
    margin-left: 10px;
}
.el-radio{
  float: left;
  border: 1px solid #409eff33;
  padding: 10px 24px;
  margin: 10px 20px;
  border-radius: 4px;
  &.is-checked{
    border-color: #409EFF;
    color: #fff;
    .el-radio__label{
      color: #fff;
    }
  }
}
.btn{
  margin-left: 20px;
}
.yearsPage{
  .el-radio__input {
    .el-radio__inner{
      display: none;
    }
    &+.el-radio__label{
      padding: 0;
    }
  }
}

.mimasjyzm{
  position: relative;
  left: 0px;
  top:0px;
  width: 120px;
  
}
.el_reg{
    position: absolute;
    top: 0px;
    left: 115px;
    height: 100%;
    background: #ecf5ff;
    color: #3a8ee6;
    border-radius: 0 4px 4px 0;
    border-color: #c6e2ff;
    border-left-color: #3a8ee6;
}

</style>



// WEBPACK FOOTER //
// TrialList.vue?7252a30e